import teacherRoutes from './sub_modules/teacher/routes.js'

export default [...teacherRoutes]
